<template>
    <Spinner v-if="displaySpinner" />
    <div class="title-and-controls">
        <EditableTitle v-model="role" icon="pi pi-id-card" />
        <div class="controls">
            <Button
                v-if="description && !description.content && isEditing"
                v-tooltip.bottom="{
                    value: 'Will generate a first draft of the description based on the context.',
                    showDelay: 100,
                }"
                class="p-button-secondary"
                icon="pi pi-sparkles"
                label="Generate first draft"
                @click="generateRoleDescription"
            />
        </div>
    </div>
    <section :class="['description', { 'edit': isEditing }]">
        <TextAppArtefact
            v-if="role?.identity && description"
            v-model="description"
            :entityId="role.identity"
            :entityType="EntityType.ROLE"
            :isEditing="isEditing"
            :stekzModel="role"
            ref="textAppArtefact"
        />
    </section>
</template>

<script setup lang="ts">
import Spinner from "@/shared/Spinner.vue";
import TextAppArtefact from "@/components/TextAppArtefact.vue";
import EditableTitle from "@/components/EditableTitle.vue";
import { ref, watch } from "vue";
import { useRoleManager } from "@/composables/role-manager";
import { useEditManager } from "@/composables/edit-manager";
import { EntityType } from "@/stores/entity-store";
import { useGenerateDescriptionDialog } from "@/composables/generate-description";

const { isEditing } = useEditManager();
const { role, isFetching, description } = useRoleManager();
const { generateContent } = useGenerateDescriptionDialog();

const displaySpinner = ref(false);

watch(isFetching, (newValue) => (displaySpinner.value = newValue), {
    immediate: true,
});

const generateRoleDescription = async () => {
    if (!role.value) {
        return;
    }
    await generateContent(
        role.value.identity,
        EntityType.ROLE,
        description.value?.updateContent.bind(description.value)
    );
};
</script>

<style scoped lang="scss">
.controls {
    text-wrap-mode: nowrap;
}

section {
    border: 1px solid transparent;
    padding: 1rem;

    &.description {
        padding-top: 0;
        z-index: 3;
    }

    &.edit {
        border-color: var(--stekz-outline);
        border-radius: 0.5rem;

        &.description {
            padding: 0;
        }
    }
}
</style>
